'use strict';

angular.module('atex.dam').controller('DamWebLevels', [
  '$scope', '$rootScope', '$http', '$q', '$window', '$modal', '$translate', 'AuthenticationService', 'DamSearchService', 'UIConfigurationService', 'DeskSiteService', 'configuration', 'DamService', 'DamNotificationService', 'Application',
  function($scope, $rootScope, $http, $q, $window, $modal, $translate, AuthenticationService, DamSearchService, UIConfigurationService, DeskSiteService, configuration, DamService, DamNotificationService, Application) {

    var damContentPageServiceFactory = function() {
      var duplicate = function(params) {
        params = params || {};
        var sourcePageId = params.sourcePageId;
        var targetParentId = params.targetParentId;
        var title = params.title || '';
        var description = params.description || '';
        if (!sourcePageId || !targetParentId) {
          return $q.reject('Missing sourcePageId or targetParentId');
        }

        var obj = {
          sourcePageId: sourcePageId,
          targetParentId: targetParentId,
          title: title,
          description: description
        };

        return AuthenticationService.callWithAuthentication(function (currentUser) {
          var url = "/onecms/dam/page/duplicate";
          return $http({
            method: 'POST',
            url: url,
            data: obj,
            headers: {
              'Content-Type': 'application/json',
              'X-Auth-Token': currentUser.authToken
            }
          });
        });
      };

      return {
        duplicate: duplicate
      };
    };

    $scope.widgetConfig = {
      excludedSites: ['dam.d'],
      fetchSectionsAtStart: false,
      openFirstLevel: true,
      openAllLevels: false,
      allowCreationFromLevel: 1,
      find: {
        size: 28,
        debounce: 200
      },
      search: {
        enabled: true,
        webStatus: ["published"],
        printStatus: [],
        engagement: ["*"]
      }
    };

    $scope.searchText = '';
    $scope.selectedNode = undefined;
    $scope.permissionPromiseMap = {};
    $scope.permissionMap = {};
    $scope.configReadyDeferred = $q.defer();

    var damContentPageService = damContentPageServiceFactory();

    var washContentId = function (id) {
      return id.replace('contentid/', '');
    };

    var processSites = function(sites) {
      var showNode = function(node) {
        if (node.children.length > 0) {
          node.display = true;
        }
      };

      var hideNode = function(node) {
        if (node.display) {
          node.display = false;
        }
      };

      var unselectNode = function(node) {
        node.selected = false;
      };

      var setParent = function(node, level) {
        node.level = level;
        _.each(node.children, function(n) {
          n.parent = node;
          setParent(n, level + 1);
        });
      };

      var onAllLevels = function(node, cb) {
        cb(node);
        _.each(node.children, function(n) {
          onAllLevels(n, cb);
        });
      };

      _.each(sites, function (site) {
        onAllLevels(site, $scope.widgetConfig.openAllLevels ? showNode : hideNode);
        onAllLevels(site, unselectNode);
        setParent(site, 0);
        if ($scope.widgetConfig.openFirstLevel) {
          showNode(site);
        }
      });

      return sites;
    };

    var createTree = function(sites) {
      _.each(sites, function (site) {
        site.children = site.children || [];
        site.name = site.name || site.label;
        site.isSite = true;
      });
      processSites(sites);
      return sites;
    };

    var deepTreeCopy = function(node, options) {
      options = options || {};
      var copyChildren = options.copyChildren || true;
      var children = [];
      if (copyChildren) {
        _.each(node.children, function (n) {
          children.push(deepTreeCopy(n));
        });
      }
      var newNode = angular.copy(node);
      // remove "parent" otherwise when we read it back it will cause circular reference.
      // we will also remove "runtime" properties which will just re-calculated when we read it back.
      var props = ['parent', 'selected', 'display', 'level'];
      _.each(props, function(prop) {
        if (newNode[prop]) {
          delete newNode[prop];
        }
      });
      newNode.children = children;
      return newNode;
    };

    var storeTree = function(treeId, sites) {
      var sitesCopy = [];
      _.each(sites, function(site) {
        sitesCopy.push(deepTreeCopy(site));
      });
      $window.localStorage.setItem(treeId, JSON.stringify(sitesCopy));
    };

    var readTree = function (treeId) {
      var tree = $window.localStorage.getItem(treeId);
      if (tree) {
        return processSites(JSON.parse(tree));
      }
      return tree;
    };

    var getRemoteSites = function() {
      var config = {
        showSubPages: true,
        excludedSites: $scope.widgetConfig.excludedSites
      };
      return DeskSiteService.getWorkingSites().then(function (workingSites) {
        return DeskSiteService.getSites(workingSites.map(function (workingSite) {
          return {id: workingSite};
        }), config);
      });
    };

    var getSitesTree = function(forceRefresh) {
      var currentUserId = Application.currentUser ? Application.currentUser.userId : '';
      var treeId = "desk-site-widget-tree-0591-" + currentUserId;

      var tree;
      if (!forceRefresh) {
        tree = readTree(treeId);
      }
      if (tree) {
        return $.when(tree);
      } else {
        return getRemoteSites().then(function (sites) {
          tree = createTree(sites);
          storeTree(treeId, tree);
          return tree;
        });
      }
    };

    $scope.configReady = function() {
      return $scope.configReadyDeferred.promise;
    };

    $scope.$on("dam:loadConfigurationEnd", function () {
      $scope.configReady().then(function(config) {
        if (config.enabled) {
          if (config.fetchSectionsAtStart) {
            $scope.openHomePages();
          } else {
            $scope.initEmptyHomePages();
          }
        }
      });
    });

    $scope.$on("dam:logout", function () {
      $scope.sites = undefined;
    });

    $scope.initEmptyHomePages = function() {
      $scope.loading = false;
      $scope.error = false;
      $scope.searchText = '';
      $scope.sites = [];
    };

    $scope.openHomePages = function (forceRefresh) {
      $scope.loading = true;
      $scope.error = false;
      $scope.searchText = '';
      $scope.sites = [];
      $('#pWebLevelsSearchBox').val('');
      getSitesTree(forceRefresh).then(function (sites) {
        $scope.sites = sites;
        $scope.loading = false;
      }).then(null, function () {
        $scope.loading = false;
        $scope.error = true;
      });
    };

    $scope.search = function (node, event) {
      $scope.toggleSelection(node);
      if (event.altKey) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      var id = washContentId(node.id).replace('policy;', '');
      var q = {
        hiddenQuery: true,
        sortValue: "originalCreationTime_dt",
        sortOrderValue: "desc",
        fields: [
          {
            key: "page_ss",
            values: [id],
            type: "LIST",
            useId: false
          },
          {
            key: "physicalPage_ss",
            values: ["false"],
            type: "BOOLEAN",
            useId: false
          }
        ]
      };
      var searchConfig = $scope.widgetConfig.search || {};
      var webStatuses = searchConfig.webStatus || [];
      var printStatuses = searchConfig.printStatus || [];
      var engagements = searchConfig.engagement || [];
      if (webStatuses.length > 0) {
        q.fields.push({
          key: "web_status_id_s",
          values: webStatuses,
          type: "LIST",
          useId: false
        });
      }
      if (printStatuses.length > 0) {
        q.fields.push({
          key: "content_status_id_s",
          values: printStatuses,
          type: "LIST",
          useId: false
        });
      }
      if (engagements.length > 0) {
        q.fields.push({
            key: "engagement_app_type_atex_desk_sm",
            values: engagements,
            type: "ENGAGE",
            useId: false
          }
        );
      }
      var ts = Date.now();
      DamSearchService.setLastQueryStartTs(ts);
      var extraInfo = {
        queryTs: ts,
        id: node.id,
        name: node.name,
        viewMode: "thumb_list",
        type: "webSection"
      };

      $rootScope.$broadcast("dam:resetQueuesSelection");
      $rootScope.$broadcast("dam:resetFoldersSelection");

      DamSearchService.advancedSearch(q, extraInfo);
    };

    $scope.toggleSelection = function(node) {
      if ($scope.selectedNode) {
        $scope.selectedNode.selected = false;
      }
      node.selected = true;
      $scope.selectedNode = node;
    };

    $scope.toggleNode = function(node) {
      if (node.children.length > 0) {
        node.display = !node.display;
      }
      $scope.toggleSelection(node);
    };

    $scope.hasSectionCreatePermission = function(parentId) {
      parentId = washContentId(parentId);
      var p = $scope.permissionPromiseMap[parentId];
      if (!p) {
        var deferred = $q.defer();
        $scope.permissionPromiseMap[parentId] = deferred.promise;
        var req = atex.dam.AngularUtils.buildPermissionRequest(parentId, "2CREATE", false);
        DamService.permission(req).then(function (response) {
          deferred.resolve(response.data);
          $scope.permissionMap[parentId] = response.data;
        }, function (error) {
          deferred.reject(error);
        });
      }
      return $scope.permissionMap[parentId];
    };

    $scope.canAddWebSection = function () {
      var curNode = $scope.selectedNode;
      if (curNode) {
        if (curNode.level >= $scope.widgetConfig.allowCreationFromLevel) {
          return $scope.hasSectionCreatePermission(curNode.id);
        }
      }
      return false;
    };

    $scope.canDuplicateWebSection = function() {
      var curNode = $scope.selectedNode;
      if (curNode && curNode.parent) {
        var fromLevel = $scope.widgetConfig.allowCreationFromLevel + 1;
        if (curNode.level >= fromLevel) {
          return $scope.hasSectionCreatePermission(curNode.parent.id);
        }
      }
      return false;
    };

    $scope.canShowMenu = function() {
      if ($scope.selectedNode) {
        return $scope.canAddWebSection() || $scope.canDuplicateWebSection();
      }
      return false;
    };

    $scope.showCreateNewSectionModal = function(options) {
      options = options || {};

      // calculate default parameters
      var selectedParentNode = options.parentNode;
      var templateNode = options.templateNode;
      var showSites = typeof options.showSites !== 'undefined' ? options.showSites : true;

      // check if we have a selected node
      if (!selectedParentNode) {
        var message = "No section selected";
        if ($translate.getTranslationTable()) {
          message = $translate.getTranslationTable()['WEB_SECTIONS_PANEL.NO_SECTION_SELECTED'];
        }
        DamNotificationService.addNotification(atex.dam.Notification({type: 'warning', message: message}), true);
        return;
      }
      var getSiteFromNode = function(node) {
        if (node.isSite) {
          return node;
        } else if (node.parent) {
          return getSiteFromNode(node.parent);
        } else {
          console.log('no site found and no parent found for', node);
          return node;
        }
      };
      var getNode = function (node, id) {
        if (node.id === id) {
          return node;
        } else {
          for (var idx = 0; idx < node.children.length; idx++) {
            var child = node.children[idx];
            var childNodeFound = getNode(child, id);
            if (childNodeFound) {
              return childNodeFound;
            }
          }
        }
        return undefined;
      };
      var getNodePath = function (node) {
        var path = [node];
        if (node.parent) {
          path = getNodePath(node.parent).concat(path);
        }
        return path;
      };
      var parentNode = deepTreeCopy(selectedParentNode, { copyChildren: false });
      var sites = createTree([deepTreeCopy(getSiteFromNode(selectedParentNode))]);
      var modalScope = $rootScope.$new(true);
      modalScope.parentNode = parentNode;
      modalScope.sites = sites;
      modalScope.templateNode = templateNode;
      modalScope.showSites = showSites;
      modalScope.toNodePath = function(node) {
        return getNodePath(getNode(sites[0], node.id)).map(function (n) {
          return n.name;
        }).join('/');
      };
      var modal = $modal({
        show : true,
        scope : modalScope,
        template : 'views/dam-web-levels-modal.html',
        modalClass : 'dam-modal-edit confirm-modal ng-cloak',
        backdrop : 'static',
        keyboard : false
      });
      var destroyModal = function() {
        modal.then(function(modalEl) {
          modalEl.on('hidden.bs.modal', function() {
            modalScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      modalScope.doCancel = function() {
        destroyModal();
      };
      modalScope.doCreate = function(params) {
        destroyModal();
        damContentPageService.duplicate({
          sourcePageId: washContentId(params.templateNode.externalId),
          targetParentId: washContentId(params.parentNode.externalId),
          title: params.pageName,
          description: params.pageDescription
        }).then(function(response) {
          var newPageId = response.data.pageId;
          console.log('new page id', newPageId);
          var message = $translate.getTranslationTable() ? $translate.getTranslationTable()['WEB_SECTIONS_PANEL.SECTION_CREATED'] : 'Section created';
          DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: message}), false);
          $scope.refreshWebLevels();
        }, function(error) {
          console.log('error calling duplicate', error);
          var errorData = error.data || {
            message: error.statusText + ' (' + error.status + ')',
            statusCode: error.status
          };
          var message;
          if ($translate.getTranslationTable()) {
            message = $translate.getTranslationTable()['WEB_SECTIONS_PANEL.DUPLICATE_ERROR'];
          }
          message += errorData.message;
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      };
    };

    $scope.createNewWebSection = function() {
      return $scope.showCreateNewSectionModal({
        parentNode: $scope.selectedNode
      });
    };

    $scope.duplicateWebSection = function() {
      return $scope.showCreateNewSectionModal({
        parentNode: $scope.selectedNode.parent,
        templateNode: $scope.selectedNode,
        showSites: false
      });
    };

    $scope.refreshWebLevels = function(event) {
      $scope.permissionPromiseMap = {};
      $scope.permissionMap = {};
      $scope.openHomePages(true);
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    $scope.filter = function (event) {
      var text = $('#pWebLevelsSearchBox').val();
      if (text && text.length > 0) {
        getSitesTree().then(function (sites) {
          var doNodeMatch = function(node, text) {
            return node.name.toLowerCase().indexOf(text) >= 0;
          };
          var doFilter = function(node, text) {
            if (node.children.length > 0) {
              for (var idx = node.children.length - 1; idx >= 0; idx--) {
                var child = node.children[idx];
                if (!doFilter(child, text)) {
                  node.children.splice(idx, 1);
                }
              }
              // return true if any child is visible or the node itself match.
              node.display = doNodeMatch(node, text) || node.children.length > 0;
            } else {
              node.display = doNodeMatch(node, text);
            }
            return node.display;
          };
          var newSites = [];
          _.each(sites, function (site) {
            if (doFilter(site, text.toLowerCase())) {
              newSites.push(site);
            }
          });
          $scope.sites = newSites;
        });
      } else {
        $scope.openHomePages();
      }
      return true;
    };

    $scope.init = function () {
      configuration.whenReady().then(function () {
        var config = configuration.getWebSectionWidget() || {};
        $scope.widgetConfig = _.extend({}, $scope.widgetConfig, config);
        $scope.configReadyDeferred.resolve($scope.widgetConfig);
      });
    };

    // The IsOpen of the accordion is two levels above this scope
    $scope.$parent.$parent.$watch('isOpen', function (newValue, oldValue) {
      if (newValue) {
        $scope.$root.$broadcast("dam:webTreeSectionsOpen", newValue);
      }
    });

    $scope.$on('dam:webTreeSectionsOpen', function () {
      if (!$scope.widgetConfig.fetchSectionsAtStart && (!$scope.sites || $scope.sites.length === 0)) {
        $scope.openHomePages();
      }
    });

    $scope.init();
  }]);

angular.module('atex.dam').controller('DamWebLevelsModalController', [
  '$scope',
  function($scope) {

    $scope.pageName = '';

    $scope.toggleSelection = function(node) {
      if ($scope.templateNode) {
        $scope.templateNode.selected = false;
      }
      node.selected = true;
      $scope.templateNode = node;
    };

    $scope.toggleNode = function(node) {
      if (node.children.length > 0) {
        node.display = !node.display;
      }
    };

    $scope.isOkEnabled = function() {
      var templateSelected = ($scope.templateNode !== undefined);
      var isNameNotEmpty = ($scope.pageName.trim() !== '');
      return templateSelected && isNameNotEmpty;
    };

    $scope.doOk = function () {
      return $scope.doCreate({
        parentNode: $scope.parentNode,
        templateNode: $scope.templateNode,
        pageName: $scope.pageName,
        pageDescription: $scope.pageDescription
      });
    };
  }
]);
